import React, { useState } from 'react';

const DraggableBox = ({ children, style, defaultX = 0, defaultY = 0, onPositionChange, boxRef }) => {
    const [boxPosition, setBoxPosition] = useState({ x: defaultX, y: defaultY });

    const startDrag = (clientX, clientY) => {

        const startX = clientX - boxPosition.x;
        const startY = clientY - boxPosition.y;

        const onMove = (moveX, moveY) => {
            const newPosition = {
                x: moveX - startX,
                y: moveY - startY,
            }
            setBoxPosition(newPosition);

            if (onPositionChange) onPositionChange(newPosition);
        };

        const onMouseMove = (e) => onMove(e.clientX, e.clientY);
        const onTouchMove = (e) => onMove(e.touches[0].clientX, e.touches[0].clientY);


        const onEnd = () => {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onEnd);
            document.removeEventListener("touchmove", onTouchMove);
            document.removeEventListener("touchend", onEnd);
        };

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onTouchMove);
        document.addEventListener("touchend", onEnd);
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        startDrag(e.clientX, e.clientY);
    };

    const handleTouchStart = (e) => {
        e.preventDefault();
        startDrag(e.touches[0].clientX, e.touches[0].clientY);
    };

    return (
        <div
            ref={boxRef}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
            style={{
                position: "absolute",
                left: boxPosition.x,
                top: boxPosition.y,
                cursor: "grab",
                ...style,
            }}
        >
            {children}
        </div>
    );
};

export default DraggableBox;